export const CHECKOUT_DETAIL_ACTION_KEYS: string[] = [
  'redirectDetail',
  'detail',
  'edit',
  'open',
  'detail_newTab',
];
